module.exports = __webpack_public_path__ + "img/ic-data-4.02d59e01.svg";